import React from 'react';
import { Button } from 'react-bootstrap';
import useStyles from '../../css/style';

interface PagingProps {
  totalData: number;
  currentPage: number;
  perPage: number;
  onPageChange: (changeAmount: number) => void;
}

const Paging: React.FC<PagingProps> = ({
  totalData,
  currentPage,
  perPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalData / perPage);
  const jumpPages = 10;
  const classes = useStyles(); // スタイリングを取得

  const indexOfLast =
    currentPage * perPage <= totalData ? currentPage * perPage : totalData;
  const indexOfFirst = currentPage * perPage - perPage;

  return (
    <div>
      <Button
        variant="link"
        onClick={() => onPageChange(1 - currentPage)}
        disabled={currentPage === 1 || currentPage === 0}
        style={{ fontWeight: 'bold', alignSelf: 'center' }}
        title="先頭ページへ移動"
      >
        ｜＜
      </Button>
      <Button
        variant="link"
        onClick={() => onPageChange(-jumpPages)}
        disabled={currentPage <= jumpPages}
        style={{ fontWeight: 'bold', alignSelf: 'center' }}
        title={`${jumpPages}ページ前`}
      >
        ＜＜
      </Button>
      <Button
        variant="link"
        onClick={() => onPageChange(-1)}
        disabled={currentPage === 1 || currentPage === 0}
        style={{ fontWeight: 'bold', alignSelf: 'center' }}
        title="1ページ前"
      >
        ＜
      </Button>
      <span className={classes.pagingText}>
        {`${
          totalData !== 0 ? indexOfFirst + 1 : 0
        }～${indexOfLast}件目/${totalData}件中`}
      </span>
      <Button
        variant="link"
        onClick={() => onPageChange(1)}
        disabled={currentPage === totalPages || totalPages === 0}
        style={{ fontWeight: 'bold', alignSelf: 'center' }}
        title="1ページ後"
      >
        ＞
      </Button>
      <Button
        variant="link"
        onClick={() => onPageChange(jumpPages)}
        disabled={currentPage > totalPages - jumpPages}
        style={{ fontWeight: 'bold', alignSelf: 'center' }}
        title={`${jumpPages}ページ後`}
      >
        ＞＞
      </Button>
      <Button
        variant="link"
        onClick={() => onPageChange(totalPages - currentPage)}
        disabled={currentPage === totalPages || totalPages === 0}
        style={{ fontWeight: 'bold', alignSelf: 'center' }}
        title="最終ページへ移動"
      >
        ＞｜
      </Button>
    </div>
  );
};

export default Paging;
